var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-loader-wrapper"},[_c('content-loader',{attrs:{"width":_vm.width,"height":_vm.height,"speed":2,"primary-color":"#f3f3f3","secondary-color":"#ecebeb"}},[_c('rect',{attrs:{"x":"0","y":"0","rx":"0","ry":"0","width":_vm.width,"height":_vm.height}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }